import React, { useEffect, useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'

export default function SendEmergencyNow({ isOpen, setIsOpen, sendData, SendEmergencyInCurrentQueue, loding }) {
  const [data, setData] = useState({
    Id: 0,
  })

  useEffect(() => {
  if (sendData) {
    setData({
      ...sendData,
      Id: sendData.Id ?? sendData.id
    })
  }
}, [sendData])


  const handleSubmit = (e) => {
    e.preventDefault()
    SendEmergencyInCurrentQueue(data)
  }

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"Send Emergency To Confirm"}>
      <form onSubmit={handleSubmit}>
        <div className="p-6 space-y-6">
          <div className="grid grid-cols gap-6">
            <div className="col-span-12 text-center text-2xl">
              <label className="block mb-2 font-medium text-gray-900 ">Patient Name</label>
              <p className="text-5xl font-semibold text-gray-800">{data.patientName}</p>
            </div>
            <div className="col-span-12 sm:col-span-6 ml-20">
              <label className="block mb-2 text-xl font-medium text-gray-900 ">Address</label>
              <p className="text-2xl font-bold text-gray-800">
                {data.patientAddress} 
              </p>
            </div>
            <div className="col-span-12 sm:col-span-6 ml-20">
              <label className="block mb-2 text-xl font-medium text-gray-900 ">Number</label>
              <p className="text-2xl font-bold text-gray-800">{data.opdNumberAlloted}</p>
            </div>
          </div>
        </div>
        <div className="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b ">
          {!loding ? (
            <>
              <button type="submit" className="btn-danger">Yes</button>
              <button onClick={() => setIsOpen(false)} className="btn-default">Cancel</button>
            </>
          ) : (
            <LodingButton text="Wait.." css="btn-danger-disabled" />
          )}
        </div>
      </form>
    </Modal>
  )
}
